export function mapArrayToObject(input, getKey = (_, index) => index, ignoreUndefinedOrNull = false) {
    return input.reduce((res, elem, index) => {
        const key = getKey(elem, index);
        if (ignoreUndefinedOrNull && key == null) {
            return res;
        }
        res[key] = elem;
        return res;
    }, {});
}
export function groupBy(input, getKey = (_, index) => index) {
    return input.reduce((res, elem, index) => {
        const key = getKey(elem, index);
        res[key] = [...(res[key] ?? []), elem];
        return res;
    }, {});
}
export function mapValues(input, mapper, target = {}) {
    return Object.entries(input)
        .reduce((target, [key, value]) => {
        const [newKey, newValue] = mapper(key, value, input);
        target[newKey] = newValue;
        return target;
    }, target);
}
export function filterKeys(input, filter, target = {}) {
    return Object.entries(input)
        .reduce((res, [key, value]) => {
        const flag = filter(key, value, input);
        if (flag) {
            res[key] = value;
        }
        return res;
    }, target);
}
export function omitKeys(object, keys) {
    return Object.keys(object)
        .filter((key) => !keys.includes(key))
        .reduce((merge, key) => {
        const rKey = key;
        merge[rKey] = object[rKey];
        return merge;
    }, {});
}
export function shallowEqual(a, b) {
    if (a == null || b == null) {
        return a === b;
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }
        return a.every((e, i) => e === b[i]);
    }
    if (typeof a === 'object' && typeof b === 'object') {
        const keysA = Object.keys(a);
        const keysB = Object.keys(b);
        if (keysA.length !== keysB.length) {
            return false;
        }
        // @ts-ignore
        return keysA.every((keyA, i) => keysB[i] === keyA && a[keyA] === b[keyA]);
    }
    return a === b;
}
export function map(input, map) {
    const output = {};
    for (const key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            output[key] = map(input[key], key);
        }
    }
    return output;
}
//# sourceMappingURL=object.js.map